export const isString = (variable: string | boolean | undefined) => {
    return typeof variable === "string";
};
